import { Fragment } from 'react';
import { Container } from '@/components/container';
import {
  Toolbar,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from '@/partials/toolbar';
import { PageNavbar } from '@/pages/account';
import { useLayout } from '@/providers';
import { useNavigate } from 'react-router-dom';
import AddKYCForm from './components/AddKYCForm';

const ViewKYC = () => {
  const { currentLayout } = useLayout();
  const navigate = useNavigate();

  return (
    <Fragment>
      <PageNavbar />
      {currentLayout?.name === 'demo1-layout' && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle text="View KYC" />
              <ToolbarDescription>
                View your KYC record details below.
              </ToolbarDescription>
            </ToolbarHeading>
          </Toolbar>
        </Container>
      )}
      <Container>
        <AddKYCForm mode="view" onSuccess={() => navigate('/user-kyc')} />
      </Container>
    </Fragment>
  );
};

export { ViewKYC };
